(function () {
  var N = window.NUVOK || { root: '/', moneyFormat: '${{amount}}' };
  var R = N.root.slice(-1) === '/' ? N.root : N.root + '/';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function money(cents) {
    var fmt = N.moneyFormat || '${{amount}}';
    function delim(n, d, t, s) { var p = (n / 100).toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? s + p[1] : ''); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return delim(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return delim(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return delim(cents, 0, '.', ',');
      return delim(cents, 2, ',', '.');
    });
  }

  /* ---------- overlays ---------- */
  function lock(on) { document.documentElement.classList.toggle('lock', on); }
  function openDrawer() { var d = $('[data-drawer]'); if (!d) return; d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); lock(true); }
  function closeDrawer() { var d = $('[data-drawer]'); if (!d) return; d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); lock(false); }
  function toggle(sel, on) { var el = $(sel); if (!el) return; el.classList.toggle('open', on); el.setAttribute('aria-hidden', on ? 'false' : 'true'); lock(on); }

  function refreshCart() {
    return fetch(R + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var tmp = document.createElement('div'); tmp.innerHTML = j['cart-drawer'];
        var fresh = $('[data-drawer-inner]', tmp), cur = $('[data-drawer-inner]');
        if (fresh && cur) cur.replaceWith(fresh);
        return fetch(R + 'cart.js', { credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$('[data-bag-count]').forEach(function (e) { e.textContent = c.item_count; }); return c; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-drawer-close]')) { closeDrawer(); return; }
    if (t.closest('[data-menu-open]')) { toggle('[data-menu]', true); return; }
    if (t.closest('[data-menu-close]')) { toggle('[data-menu]', false); return; }
    if (t.closest('[data-size-guide]')) { e.preventDefault(); toggle('[data-size-modal]', true); return; }
    if (t.closest('[data-size-close]')) { toggle('[data-size-modal]', false); return; }
    var ch = t.closest('[data-change]');
    if (ch) {
      var line = parseInt(ch.closest('[data-line]').getAttribute('data-line'), 10);
      var row = ch.closest('[data-line]'); row.classList.add('is-busy');
      fetch(R + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: parseInt(ch.getAttribute('data-change'), 10) }) })
        .then(refreshCart).catch(function () { window.location.href = R + 'cart'; });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer(); toggle('[data-menu]', false); toggle('[data-size-modal]', false);
  });

  /* ---------- product ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var form = $('form[action*="/cart/add"]', root);
    var idInput = $('input[name="id"]', form);
    var btn = $('[data-add]', root), err = $('[data-form-error]', root);
    var n = data.options.length;
    function sel() { var v = []; for (var i = 0; i < n; i++) { var c = $('[data-opt="' + i + '"]:checked', root); v.push(c ? c.value : null); } return v; }
    function match(v, vals, onlyAvail) { for (var i = 0; i < vals.length; i++) { if (vals[i] !== null && v.options[i] !== vals[i]) return false; } return onlyAvail ? v.available : true; }
    function exact(vals) { if (vals.indexOf(null) > -1) return null; for (var i = 0; i < data.variants.length; i++) if (match(data.variants[i], vals)) return data.variants[i]; return null; }
    function mark(vals) {
      $$('[data-opt]', root).forEach(function (r) {
        var i = +r.getAttribute('data-opt'), t = vals.slice(); t[i] = r.value;
        var ok = data.variants.some(function (v) { return match(v, t, true); });
        if (r.nextElementSibling) r.nextElementSibling.classList.toggle('na', !ok);
      });
    }
    function update() {
      var vals = sel();
      vals.forEach(function (val, i) { var f = $('[data-option-index="' + i + '"] [data-opt-value]', root); if (f) f.textContent = val || ''; });
      mark(vals);
      if (err) err.textContent = '';
      var v = exact(vals);
      if (v) {
        idInput.value = v.id;
        $$('[data-price]', root).forEach(function (p) { p.textContent = money(v.price); });
        btn.disabled = !v.available; btn.textContent = v.available ? 'Add to Bag' : 'Sold out';
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (x) {}
        if (v.featured_media) {
          var m = $('[data-media-id="' + v.featured_media.id + '"]', root), media = $('[data-media]', root);
          if (m && media && media.firstElementChild !== m) { media.insertBefore(m, media.firstElementChild); media.scrollLeft = 0; }
        }
      } else { btn.disabled = false; btn.textContent = 'Add to Bag'; }
    }
    $$('[data-opt]', root).forEach(function (r) { r.addEventListener('change', update); });
    mark(sel());

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var vals = sel(), miss = vals.indexOf(null);
      if (miss > -1) { err.textContent = 'Please select a ' + String(data.options[miss]).toLowerCase() + '.'; var o = $('[data-option-index="' + miss + '"]', root); if (o) o.scrollIntoView ? window.scrollTo({ top: o.getBoundingClientRect().top + window.pageYOffset - 160, behavior: 'smooth' }) : 0; return; }
      var v = n ? exact(vals) : data.variants[0];
      if (!v || !v.available) { err.textContent = 'This combination is currently unavailable.'; return; }
      idInput.value = v.id;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch(R + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'This piece could not be added.'); return j; }); })
        .then(refreshCart)
        .then(openDrawer)
        .catch(function (x) { err.textContent = x.message; })
        .then(function () { btn.disabled = false; btn.textContent = 'Add to Bag'; });
    });

    var sticky = $('[data-sticky-buy]', root);
    if (sticky) {
      $('[data-sticky-add]', sticky).addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : btn.click(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { sticky.classList.toggle('show', !en[0].isIntersecting); }).observe(btn);
      } else sticky.classList.add('show');
    }
  }

  /* ---------- collection ---------- */
  function initCollection() {
    var form = $('[data-filter-form]'), sort = $('[data-sort]'), tgl = $('[data-filter-toggle]');
    if (tgl && form) tgl.addEventListener('click', function () { form.hidden = !form.hidden; tgl.setAttribute('aria-expanded', String(!form.hidden)); });
    if (form) {
      var timer;
      form.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(function () { form.submit(); }, 250); });
      $$('.chip input', form).forEach(function (i) { i.addEventListener('change', function () { i.parentNode.classList.toggle('on', i.checked); }); });
    }
    if (sort) sort.addEventListener('change', function () {
      if (form) { $('[data-sort-input]', form).value = sort.value; form.submit(); return; }
      var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location.href = u.toString();
    });
  }

  function boot() { $$('[data-product]').forEach(initProduct); initCollection(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
